export default {

  todaysWins(state, data) {
    state.todaysWins = data;
  },
  todaysBigTask(state, data) {
    state.todaysBigTask = data;
  },
  todaysSmallTasks(state, data) {
    state.todaysSmallTasks = data;
  },

};
